import React, { useContext } from "react";
import Modal from "react-bootstrap/Modal";

import { PrProfileContext } from "../../data/pr_profile_context_management";
import usePrExpertsApi from "../../data/use_pr_experts_api";
import ServerErrorAlert from "../../../profiles/ServerErrorAlert";
import AddExpertInput from "./add_expert_card/AddExpertInput";

// The Add surface for represented experts. Only the picker lives here: removal happens inline on the
// page's RepresentsSection, so this body does not restate the represented list. A successful add
// requests the Experts tab and closes.
function ExpertsModalBody({ close }) {
  const context = useContext(PrProfileContext);
  const { representedExperts, generalError, setActiveTabRequest } = context;
  const { addExpert } = usePrExpertsApi({ ...context });

  const excludedExpertIds = (representedExperts || []).map((expert) => expert.id);

  return (
    <>
      <Modal.Body>
        <ServerErrorAlert generalError={generalError} />
        <div className="row g-2">
          <AddExpertInput
            existingExpertsIds={excludedExpertIds}
            onSubmit={async (expertId) => {
              // Stay open on failure so the alert above is what the viewer sees, not a vanished modal.
              const { saved } = await addExpert(expertId);
              if (saved) {
                setActiveTabRequest("experts");
                close();
              }
            }}
            onCancel={close}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button type="button" className="btn btn-secondary" onClick={close}>
          Close
        </button>
      </Modal.Footer>
    </>
  );
}

export default ExpertsModalBody;
